import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { InMemoryCache } from '@apollo/client/cache';
import { createHttpLink } from 'apollo-link-http';
import { ApolloClient } from '@apollo/client/core';
import envConfig from '@nile/home/src/Config/env';
import { AppProvider } from '@shopify/polaris';
import { UPDATE_QUOTE_VIEW_STATUS } from '@nile/graphql';
import { useMutation } from '@apollo/client';
import styled from 'styled-components';
import {
  getHeaderValue,
  Loader,
  getCookieValue,
  getCustomSubDomain,
  toast,
  getTranslatedText
} from '@nile/components';
import { injectIntl } from 'react-intl';
import QuoteDetails from '@nile/client_management/src/Pages/Quote/QuoteDetails';
import { errorLink } from '@nile/graphql/src/QueryManager/ErrorMiddleware';

const InvoiceTemplateWrap = styled.div.attrs({
  className: 'flex center jcenter overflow-auto full-height'
})`
  background-image: url(${envConfig.imageRoot}svg/chatBg.svg);
  .Polaris-Card {
    padding: 40px;
  }
`;

const cache = new InMemoryCache({
  addTypename: false
});

let invoicePdfLoaderTimeout = null;

function QuoteTemplate(props) {
  const { intl } = props;
  const params = new URLSearchParams(props.location.search);
  const clientId = params.get('clientId');
  const quoteId = params.get('quoteId');
  const token = params.get('token');

  const AccountClient = new ApolloClient({
    cache,
    link: errorLink.concat(
      createHttpLink({
        uri: localStorage?.getItem('apiDomain') + envConfig.accountsGateway,
        credentials: 'include',
        headers: {
          ...getHeaderValue(),
          authorization: `Bearer nl-${token}`
        }
      })
    ),
    connectToDevTools: true
  });
  const [updateQuoteViewedStatus] = useMutation(UPDATE_QUOTE_VIEW_STATUS, {
    client: AccountClient
  });
  useEffect(() => {
    updateQuoteViewedStatus();
  }, []);
  return (
    <AppProvider>
      <Invoice
        clientId={clientId}
        quoteId={quoteId}
        token={token}
        AccountClient={AccountClient}
        intl={intl}
      />
    </AppProvider>
  );
}
function Invoice(props) {
  const { clientId, quoteId, token, AccountClient, intl } = props;
  const [pdfDownloading, setPDFDownload] = useState(false);
  const [ispdfDownloading, setPDFDownloadLoading] = useState(false);

  const downloadPDF = async () => {
    setPDFDownload(true);
    const urlPrefix = window.location.protocol + '//';
    const urlSufix = '/file-ud-web/fileUD';
    // const downloadDetails = new URL(`${envConfig.fileRoot}/download_invoice`);
    const baseURL = localStorage?.getItem('apiDomain') + envConfig.fileRoot;
    const downloadDetails = new URL(`${baseURL}/download`);
    downloadDetails.search = new URLSearchParams({
      module: 'QUOTE',
      details: JSON.stringify({
        quoteId,
        clientId
      }),
      'nl-token': token,
      CustomerSubDomain: getCustomSubDomain(),
      'X-CSRF-TOKEN': getCookieValue('app-csrf'),
      authorization: `Bearer nl-${token}`
    });
    const requestOptions = {
      method: 'GET',
      credentials: 'include',
      headers: getHeaderValue()
    };
    if (invoicePdfLoaderTimeout) clearTimeout(invoicePdfLoaderTimeout);
    invoicePdfLoaderTimeout = setTimeout(() => {
      toast('warning', getTranslatedText(intl, 'invoice.pdf.download.time'));
      setPDFDownload(false);
    }, 1000);
    fetch(downloadDetails, requestOptions)
      .then(function(response) {
        setPDFDownloadLoading(true);
        // The response is a Response instance , parse the data into a useable format using `.json()`
        return response.json();
      })
      .then(function(data) {
        setPDFDownloadLoading(false);
        if (data?.errors) {
          toast(
            'error',
            getTranslatedText(
              intl,
              `app.errorCode.${data.errors?.[0]?.errorCode}`
            )
          );
        }
      })
      .catch((error) => {
        console.log(error);
        const a = document.createElement('a');
        a.href = downloadDetails;
        a.download = 'nameOfFile';
        a.target = '_self';
        a.click();
      });
  };

  return (
    <InvoiceTemplateWrap>
      <QuoteDetails
        quoteId={quoteId}
        accountClient={AccountClient}
        restrictActions
        redirectUrl={downloadPDF}
        isPdfDownloading={pdfDownloading || ispdfDownloading}
      />
    </InvoiceTemplateWrap>
  );
}

export default injectIntl(withRouter(QuoteTemplate));
